import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Card from '../components/card'
import Component3images from '../components/component3images'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './repair.css'

const Repair = (props) => {
  return (
    <div className="repair-container1">
      <Helmet>
        <title>Ремонт и восстановление металлических деталей | Arcobo</title>
        <meta
          name="description"
          content="Arcobo выполняет ремонт и восстановление металлических деталей методом WAAM. Наплавка изношенных поверхностей, восстановление геометрии и продление срока службы."
        />
        <meta
          property="og:title"
          content="Ремонт и восстановление металлических деталей | Arcobo"
        />
        <meta
          property="og:description"
          content="Arcobo выполняет ремонт и восстановление металлических деталей методом WAAM. Наплавка изношенных поверхностей, восстановление геометрии и продление срока службы."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Ремонт и восстановление металлических деталей | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Arcobo выполняет ремонт и восстановление металлических деталей методом WAAM. Наплавка изношенных поверхностей, восстановление геометрии и продление срока службы."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/repair"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/repair"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Repair","item":"https://arcobo.tech/repair"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name22"></HeaderMain>
      <hr className="repair-separator1"></hr>
      <Componenttextimage
        image1Src="/2_3D Printing/2_4_Materials/steel-1500w.webp"
        image1Alt="Восстановление и ремонт деталей"
        rootClassName="componenttextimageroot-class-name8"
        textComponent={
          <Fragment>
            <span className="repair-text10">
              <span>
                Arcobo выполняет восстановление изношенных и поврежденных
                металлических деталей методом роботизированной наплавки.
                Технология позволяет вернуть изделию первоначальные размеры и
                эксплуатационные характеристики без изготовления новой детали,
                сокращая сроки ремонта и затраты предприятия.
              </span>
              <br></br>
              <br></br>
              <span className="repair-text14 H1_small">
                Преимущества и выгоды:
              </span>
              <br></br>
              <span className="repair-text16">✔ </span>
              <span className="repair-text17 H1_extrasmall">
                Экономия до 90% стоимости
              </span>
              <br></br>
              <span>
                Восстанавливается только изношенная часть детали без
                необходимости изготовления нового изделия.
              </span>
              <br></br>
              <span className="repair-text21">✔ </span>
              <span className="repair-text22 H1_extrasmall">
                Сокращение сроков ремонта в несколько раз
              </span>
              <br></br>
              <span>
                Во многих случаях восстановление занимает несколько дней вместо
                недель или месяцев ожидания новой детали.
              </span>
              <br></br>
              <span className="repair-text26">✔ </span>
              <span className="repair-text27 H1_extrasmall">
                Продление срока службы оборудования
              </span>
              <br></br>
              <span>
                Наплавка позволяет многократно восстанавливать дорогостоящие
                узлы и значительно увеличить ресурс оборудования.
              </span>
              <br></br>
              <span className="repair-text31">✔ </span>
              <span className="repair-text32 H1_extrasmall">
                Минимальный расход материала
              </span>
              <br></br>
              <span>
                Металл наносится только на поврежденные участки, снижая расход
                дорогостоящих сплавов и объем последующей механической
                обработки.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Восстановление и ремонт деталей"
      ></Componenttextimage>
      <div className="repair-container2">
        <Card
          text={
            <Fragment>
              <span className="repair-text35">
                <span>
                  Восстановление уплотнительных поверхностей, седел и корпусов
                  задвижек, клапанов и вентилей. Позволяет сократить стоимость
                  ремонта до 70–90% по сравнению с изготовлением новой детали.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="Запорная арматура"
          heading1={
            <Fragment>
              <span className="repair-text38">Запорная арматура</span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/Repair/11_valve-200h.webp"
          imageAlt="Восстановление запорной арматуры"
          rootClassName="cardroot-class-name18"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="repair-text39">
                <span>
                  Наплавка изношенных кромок и восстановление геометрии рабочих
                  колес. Продлевает срок службы насосного оборудования и снижает
                  простой производства.
                </span>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="Рабочие колеса насосов"
          heading1={
            <Fragment>
              <span className="repair-text43">Рабочие колеса насосов</span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/Repair/12_pump-200h.webp"
          imageAlt="Восстановление рабочих колёс насосов"
          rootClassName="cardroot-class-name19"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="repair-text44">
                <span>
                  Восстановление посадочных мест подшипников, шеек и рабочих
                  поверхностей. Исключает необходимость изготовления нового вала
                  и сокращает сроки ремонта в несколько раз.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="Валы и оси"
          heading1={
            <Fragment>
              <span className="repair-text47">Валы и оси</span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/Repair/13_shaft-200h.webp"
          imageAlt="Восстановление валов и осей"
          rootClassName="cardroot-class-name20"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="repair-text48">
                <span>
                  Наплавка износостойких покрытий на рабочие поверхности роликов
                  металлургического и промышленного оборудования. Повышает
                  ресурс деталей в условиях интенсивного износа.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="Ролики и направляющие"
          heading1={
            <Fragment>
              <span className="repair-text51">Ролики и направляющие</span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/Repair/14_axle-200h.webp"
          imageAlt="Восстановление роликов и направляющих"
          rootClassName="cardroot-class-name21"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="repair-text52">
                <span>
                  Восстановление деталей горнодобывающей и строительной техники
                  износостойкими материалами. Значительно увеличивает срок
                  службы оборудования при абразивном износе.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="Ковши, зубья и режущие кромки"
          heading1={
            <Fragment>
              <span className="repair-text55">
                Ковши, зубья и режущие кромки
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/Repair/21_bucket-200h.webp"
          imageAlt="Восстановление ковшей и режущих кромок"
          rootClassName="cardroot-class-name22"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="repair-text56">
                <span>
                  Ремонт поврежденных участков, восстановление размеров и
                  геометрии без изготовления новой оснастки. Позволяет быстро
                  вернуть инструмент в эксплуатацию.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="repair-text59">
                Пресс-формы и технологическая оснастка
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/Repair/22_injection_mold-200h.webp"
          imageAlt="Восстановление пресс-форм"
          rootClassName="cardroot-class-name23"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="repair-text60">
                <span>
                  Восстановление посадочных поверхностей, фланцев и повреждённых
                  элементов деталей — эффективно для оборудования с долгими
                  сроками поставки
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="repair-text63">
                <span>Корпуса редукторов и оборудования</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/Repair/23_gearbox-200h.webp"
          imageAlt="Восстановление корпусов редукторов"
          rootClassName="cardroot-class-name24"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="repair-text66">
                Восстановление нестандартных деталей, изготовление которых
                невозможно из-за отсутствия запчастей — наплавка возвращает
                оборудование в работу без замены узла
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="repair-text67">
                <span>Крупногабаритные уникальные детали</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/Repair/24_unique-200h.webp"
          imageAlt="Восстановление крупногабаритных деталей"
          rootClassName="cardroot-class-name25"
        ></Card>
      </div>
      <Component3images
        image1Src="/2_3D Printing/3d_11-200h.webp"
        image1Alt="Изделие WAAM 3D-печати"
        image2Src="/2_3D Printing/3d_12-200h.webp"
        image2Alt="Изделие WAAM 3D-печати"
        image3Src="/2_3D Printing/3d_13-200h.webp"
        image3Alt="Изделие WAAM 3D-печати"
        rootClassName="component3imagesroot-class-name11"
      ></Component3images>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="repair-text70">
              <span>
                Метод подходит для восстановления валов, рабочих колес насосов,
                запорной арматуры, штоков гидроцилиндров, роликов, пресс-форм,
                ковшей, зубьев, корпусов, посадочных мест подшипников, деталей
                горнодобывающего, нефтегазового, металлургического и
                энергетического оборудования.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="repair-text73">
              <span>
                При правильно подобранной технологии восстановления ресурс
                детали сопоставим с новой, а в некоторых случаях может быть выше
                благодаря применению современных износостойких материалов. После
                восстановления выполняются механическая обработка и контроль
                качества.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="repair-text76">
              <span>
                Экономия обычно составляет 30–90% в зависимости от конструкции
                детали, стоимости материала и степени износа. Особенно выгодно
                восстанавливать дорогостоящие крупногабаритные изделия и детали
                с длительными сроками поставки.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="repair-text79">
              <span>
                Используются конструкционные, нержавеющие, инструментальные,
                жаропрочные и износостойкие материалы, а также никелевые,
                кобальтовые и специальные наплавочные сплавы. Материал
                подбирается индивидуально под условия эксплуатации детали.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="repair-text82">
              <span>Работы выполняются в несколько этапов:</span>
              <br></br>
              <span>1. Диагностика состояния детали;</span>
              <br></br>
              <span>
                1.1. Лазерное 3D-сканирование геометрии (при необходимости);
              </span>
              <br></br>
              <span>
                1.2. Определение характеристик металла (твердость, состав и
                др.);
              </span>
              <br></br>
              <span>2. Подбор материала и технологии восстановления;</span>
              <br></br>
              <span>3. Роботизированная наплавка;</span>
              <br></br>
              <span>4. Термическая обработка (при необходимости);</span>
              <br></br>
              <span>5. Механическая обработка (при необходимости);</span>
              <br></br>
              <span>6. Контроль размеров и качества.</span>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="repair-text100">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="repair-text101">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="repair-text102">answer</span>
          </Fragment>
        }
        showDiv5
        showDiv6
        showDiv7
        question1="Какие детали можно восстановить?"
        question2="Насколько восстановленная деталь надежна?"
        question3="Насколько дешевле восстановление по сравнению с изготовлением новой детали?"
        question4="Какие материалы используются при восстановлении?"
        question5="Как проходит процесс восстановления?"
        rootClassName="componentfaqroot-class-name6"
      ></Componentfaq>
      <hr className="repair-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name22"></FooterMain>
    </div>
  )
}

export default Repair
